import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from 'styled-components';
import { getColor } from '../../V2/Elements/Icons/helpers';
const Icon = React.forwardRef(function Icon({ size = 24, alt, color, className, onClick }, ref) {
    const theme = useTheme();
    const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
    return (_jsx("svg", { ref: ref, onClick: onClick, width: size, height: size, viewBox: '0 0 32 32', fill: fillColor, className: className, children: _jsxs("g", { children: [_jsx("path", { d: 'M28,28.5H4a.5.5,0,0,1-.5-.5V4A.5.5,0,0,1,4,3.5H28a.5.5,0,0,1,.5.5V28A.5.5,0,0,1,28,28.5Zm-23.5-1h23V4.5H4.5Z' }), _jsx("path", { d: 'M22,16.5H10a.5.5,0,0,1,0-1H22a.5.5,0,0,1,0,1Z' }), _jsx("path", { d: 'M16,22.5a.5.5,0,0,1-.5-.5V10a.5.5,0,0,1,1,0V22A.5.5,0,0,1,16,22.5Z' })] }) }));
});
export default React.memo(Icon);
